export default import.meta.ROLLDOWN_FILE_URL_fujqTCL8ClNI8tLIUSeVgg